import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { Refresh as RetryIcon } from '@mui/icons-material';
import { useError } from '../contexts/ErrorContext';

const AUTO_HIDE_MS = 8000;

export default function ErrorToast() {
  const { error, dismissError } = useError();

  const handleRetry = () => {
    const retryFn = error?.retryFn;
    dismissError();
    retryFn?.();
  };

  return (
    <Snackbar
      open={error !== null}
      autoHideDuration={AUTO_HIDE_MS}
      onClose={(_event, reason) => {
        if (reason !== 'clickaway') dismissError();
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={error?.severity ?? 'error'}
        variant="filled"
        onClose={dismissError}
        action={
          error?.retryFn ? (
            <Button
              color="inherit"
              size="small"
              startIcon={<RetryIcon />}
              onClick={handleRetry}
            >
              Erneut versuchen
            </Button>
          ) : undefined
        }
        sx={{ width: '100%', maxWidth: 600 }}
      >
        {error?.message}
      </Alert>
    </Snackbar>
  );
}
